import RenderRows from "./render-rows";

export default RenderRows;
